import { AxiosResponse } from 'axios';
import { call, CallEffect, PutEffect } from '@redux-saga/core/effects';
import { getFormattedValue } from './functions';
import { Action } from 'redux-saga';
import { automaticApi } from '@/settings/api';

export interface Fetch {
  callback: (success: boolean, values?: {
    id: string;
    value: number;
    text: number;
    title: string;
    mandatory: boolean;
  }[]) => void;
}

export interface RequestValuesAction {
  type: string;
  payload: Fetch;
}

const uri = "/financial/v1/debtaccount";

export default function* requestValues({
  payload,
}: RequestValuesAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse<{
    data: {
      recharges: {
        range: {
          value: string;
        }[]
        mandatory: string;
      };
    };
    status: {
      codigoRetorno: number;
    }
  }, any>
> {
  try {
    const response = yield call(automaticApi.get, uri);
    const data = response?.data;
    if (data?.status?.codigoRetorno === 0) {
      const rechargesRange = data?.data?.recharges?.range ?? [];
      const sortedValues = [...rechargesRange].sort((a, b) => Number(a.value) - Number(b.value));

      const values = sortedValues.map(item => ({
        id: item.value,
        value: Number(item.value),
        text: Number(item.value ?? 0),
        title: getFormattedValue(item.value),
        mandatory: false,
      }));

      if (Number(data?.data?.recharges?.mandatory ?? 0) > 0) {
        values.unshift({
          id: data?.data?.recharges?.mandatory,
          value: Number(data?.data?.recharges?.mandatory ?? 0),
          text: Number(data?.data?.recharges?.mandatory ?? 0),
          title: getFormattedValue(data?.data?.recharges?.mandatory),
          mandatory: true,
        });
      }

      yield call(
        payload.callback,
        true,
        values
      );
    } else {
      yield call(
        payload.callback,
        false
      );
    }
  } catch (error) {
    yield call(
      payload.callback,
      false
    );
  }
}
